import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-100 p-6 text-gray-800 dark:bg-gray-900 dark:text-white">
      <div className="mx-auto max-w-3xl rounded-lg bg-white p-8 shadow-lg dark:bg-gray-800">
        <h1 className="mb-4 text-3xl font-bold text-gray-900 dark:text-gray-100">
          Privacy Policy
        </h1>
        <p className="mb-4">Effective Date: 01 January 2025</p>
        <p className="mb-4">
          Sakinah Mart ("we," "us," or "our") values your privacy and is
          committed to protecting your personal data. This Privacy Policy
          explains how we collect, use, and share information about you when you
          use our app, Sakinah Mart, and how you can exercise your privacy
          rights.
        </p>

        <h2 className="mt-6 text-xl font-semibold text-gray-900 dark:text-gray-100">
          1. Information We Collect
        </h2>
        <ul className="ml-6 list-disc text-gray-700 dark:text-gray-300">
          <li>
            <strong>Personal Information:</strong> Name, email address, phone
            number, or other contact details provided by you.
          </li>
          <li>
            <strong>Sensitive Data:</strong> Location data, device information,
            or other sensitive data, as permitted by applicable laws.
          </li>
          <li>
            <strong>Non-Personal Information:</strong> Cookies, device
            identifiers, and analytics data to improve app functionality and
            user experience.
          </li>
        </ul>

        <h2 className="mt-6 text-xl font-semibold text-gray-900 dark:text-gray-100">
          2. How We Use Your Information
        </h2>
        <ul className="ml-6 list-disc text-gray-700 dark:text-gray-300">
          <li>Provide, operate, and maintain our app.</li>
          <li>Communicate with you regarding updates, offers, or support.</li>
          <li>Enhance user experience and improve our services.</li>
          <li>
            Comply with legal obligations or enforce our Terms of Service.
          </li>
        </ul>

        <h2 className="mt-6 text-xl font-semibold text-gray-900 dark:text-gray-100">
          3. Sharing Your Information
        </h2>
        <p className="text-gray-700 dark:text-gray-300">
          We do not sell your personal data. However, we may share information
          with:
        </p>
        <ul className="ml-6 list-disc text-gray-700 dark:text-gray-300">
          <li>
            <strong>Service Providers:</strong> Third-party vendors who assist
            in app functionality (e.g., hosting, analytics, payment processing).
          </li>
          <li>
            <strong>Legal Authorities:</strong> When required by law or to
            protect our legal rights.
          </li>
        </ul>

        <h2 className="mt-6 text-xl font-semibold text-gray-900 dark:text-gray-100">
          4. Data Security
        </h2>
        <p className="text-gray-700 dark:text-gray-300">
          We implement reasonable administrative, technical, and physical
          safeguards to protect your data from unauthorized access, use, or
          disclosure. However, no system is 100% secure, and we cannot guarantee
          absolute security.
        </p>

        <h2 className="mt-6 text-xl font-semibold text-gray-900 dark:text-gray-100">
          5. Data Retention
        </h2>
        <p className="text-gray-700 dark:text-gray-300">
          We retain your personal data only as long as necessary to fulfill the
          purposes outlined in this policy or as required by law. You may
          request data deletion by contacting us.
        </p>

        <h2 className="mt-6 text-xl font-semibold text-gray-900 dark:text-gray-100">
          6. Your Rights
        </h2>
        <ul className="ml-6 list-disc text-gray-700 dark:text-gray-300">
          <li>Access, correct, or delete your personal data.</li>
          <li>Withdraw consent for data processing at any time.</li>
          <li>
            Lodge a complaint with a data protection authority if you believe
            your rights have been violated.
          </li>
        </ul>
        <p className="text-gray-700 dark:text-gray-300">
          To exercise these rights, contact us at{" "}
          <a href="mailto:sakinahmartapp@gmail.com" className="text-blue-500">
            sakinahmartapp@gmail.com
          </a>
          .
        </p>

        <h2 className="mt-6 text-xl font-semibold text-gray-900 dark:text-gray-100">
          7. Cookies and Tracking Technologies
        </h2>
        <p className="text-gray-700 dark:text-gray-300">
          Our app may use cookies or similar technologies to collect and store
          information to improve user experience. You can manage cookies through
          your device settings.
        </p>

        <h2 className="mt-6 text-xl font-semibold text-gray-900 dark:text-gray-100">
          8. Third-Party Links
        </h2>
        <p className="text-gray-700 dark:text-gray-300">
          Our app may contain links to third-party websites. We are not
          responsible for their privacy practices. We encourage you to review
          the privacy policies of those websites.
        </p>

        <h2 className="mt-6 text-xl font-semibold text-gray-900 dark:text-gray-100">
          9. Changes to This Privacy Policy
        </h2>
        <p className="text-gray-700 dark:text-gray-300">
          We may update this policy from time to time. Changes will be effective
          when posted. We encourage you to review this policy periodically.
        </p>

        <h2 className="mt-6 text-xl font-semibold text-gray-900 dark:text-gray-100">
          10. Contact Us
        </h2>
        <p className="text-gray-700 dark:text-gray-300">
          If you have any questions or concerns about this Privacy Policy,
          please contact us:
        </p>
        <ul className="ml-6 list-disc text-gray-700 dark:text-gray-300">
          <li>
            <strong>Email:</strong>{" "}
            <a href="mailto:sakinahmartapp@gmail.com" className="text-blue-500">
              sakinahmartapp@gmail.com
            </a>
          </li>
          <li>
            <strong>Phone:</strong> +62 856-5525-3796
          </li>
          <li>
            <strong>Address:</strong> Sukolilo, Surabaya, Jawa Timur
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
